import React from 'react';

import MomentUtils from './util/LocalizedMomentUtils';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { IntlProvider } from 'react-intl';
import PropTypes from 'prop-types';

import NotificationSnackbar from 'containers/NotificationSnackbar';
import greenTheme from './containers/themes/greenTheme';
import getColorTheme from './util/getColorTheme';
import AppLocale from './lngProvider';

const AppProvider = ({ children }) => {
  const { app } = useSelector((store) => store, undefined);
  const { themeColor, locale } = app;
  const applyTheme = getColorTheme(themeColor, createTheme(greenTheme));

  const localeCode = locale?.locale || 'en';
  const currentLang = AppLocale[localeCode] || AppLocale.en;

  return (
    <ThemeProvider theme={applyTheme}>
      <MuiPickersUtilsProvider utils={MomentUtils} locale={currentLang.locale}>
        <IntlProvider locale={currentLang.locale} messages={currentLang.messages}>
          <NotificationSnackbar />
          {children}
        </IntlProvider>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppProvider;
